import { NeuNavVertical } from '@neutron/react';
import { Link } from 'react-router-dom';
import { useUserRolesRef } from '../../../../services/UserRoles';
import { SideNavLabel } from '../../SideNav.styles';

const ValidationSideNavSection = () => {
  const { pathname } = window.location;
  const {
    isEnterpriseAdmin,
    isValidationRounder,
    isAidetValidationRounder,
    isBssrValidationRounder,
    hasMultipleValidationRoles
  } = useUserRolesRef();

  const shouldShowGroupedNavigation =
    isEnterpriseAdmin || hasMultipleValidationRoles;

  if (shouldShowGroupedNavigation) {
    return (
      <NeuNavVertical
        unit="group"
        label="Validation Lists"
        data-testid="side-nav-validation-list-label"
      >
        {isValidationRounder && (
          <Link to="/account/employee-rounding-settings/nlr-list">
            <NeuNavVertical
              data-testid="side-nav-lists-nlr-label"
              active={pathname.includes('nlr-list')}
              unit="item"
            >
              <SideNavLabel>NLR / Star Coaching</SideNavLabel>
            </NeuNavVertical>
          </Link>
        )}
        {isAidetValidationRounder && (
          <Link to="/account/employee-rounding-settings/aidet-list">
            <NeuNavVertical
              data-testid="side-nav-lists-aidet-label"
              active={pathname.includes('aidet-list')}
              unit="item"
            >
              <SideNavLabel>AIDET®</SideNavLabel>
            </NeuNavVertical>
          </Link>
        )}
        {isBssrValidationRounder && (
          <Link to="/account/employee-rounding-settings/bssr-list">
            <NeuNavVertical
              data-testid="side-nav-lists-bssr-label"
              active={pathname.includes('bssr-list')}
              unit="item"
            >
              <SideNavLabel>BSSR</SideNavLabel>
            </NeuNavVertical>
          </Link>
        )}
      </NeuNavVertical>
    );
  }

  // Single link priority: NLR >> AIDET >> BSSR
  if (isValidationRounder) {
    return (
      <Link to="/account/employee-rounding-settings/nlr-list">
        <NeuNavVertical
          data-testid="side-nav-lists-nlr-label"
          active={pathname.includes('nlr-list')}
          unit="item"
        >
          <SideNavLabel>NLR Validation List</SideNavLabel>
        </NeuNavVertical>
      </Link>
    );
  }

  if (isAidetValidationRounder) {
    return (
      <Link to="/account/employee-rounding-settings/aidet-list">
        <NeuNavVertical
          data-testid="side-nav-lists-aidet-label"
          active={pathname.includes('aidet-list')}
          unit="item"
        >
          <SideNavLabel>AIDET® Validation List</SideNavLabel>
        </NeuNavVertical>
      </Link>
    );
  }

  if (isBssrValidationRounder) {
    return (
      <Link to="/account/employee-rounding-settings/bssr-list">
        <NeuNavVertical
          data-testid="side-nav-lists-bssr-label"
          active={pathname.includes('bssr-list')}
          unit="item"
        >
          <SideNavLabel>BSSR Validation List</SideNavLabel>
        </NeuNavVertical>
      </Link>
    );
  }

  return null;
};

export default ValidationSideNavSection;
